export enum WindowEvent {
    HistoryBackAndForward = 'popstate',
}
